module.exports = __webpack_public_path__ + "static/media/teach.1a79d4c8.svg";